import { apiClient } from './apiClient';

export const ORDERS_PAGE_SIZE = 50;

export async function fetchOrders({ queryKey, pageParam = 0 }) {
    const [_key, kind, query] = queryKey;
    const kindUpper = kind.toUpperCase();
    
    const params = new URLSearchParams();
    if (query) {
        params.append('search', query);
    }
    params.append('offset', pageParam);
    params.append('limit', ORDERS_PAGE_SIZE);

    const url = `/api/agent/${kindUpper}/?${params.toString()}`;
    
    const response = await apiClient(url, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}

export async function fetchOrder({ queryKey }) {
    const [_key, kind, orderName] = queryKey;
    const kindUpper = kind.toUpperCase();

    const url = `/api/agent/${kindUpper}/${orderName}/`;

    const response = await apiClient(url, {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'include',
    });

    return response.json();
}
